/**
 * TrackingInit Client Component
 *
 * 在 layout 挂载一次，初始化前台 PV/UV 埋点
 *
 * 必须挂载在 layout 顶部（首次 PV）才能全程追踪
 *
 * @date 2026-07-15
 */
'use client';

import { useEffect } from 'react';
import { initTracking } from '@/lib/tracking';

export default function TrackingInit() {
  useEffect(() => {
    // 仅在浏览器侧初始化
    try {
      initTracking();
    } catch {
      // 完全吞错（埋点不能影响主流程）
    }
  }, []);

  return null;
}
